module.exports = __webpack_public_path__ + "static/media/app_video_body.93b8d5f7.png";